export default "__VITE_PUBLIC_ASSET__8e1b4c5e__"